// ** React Import
//import { useState } from 'react';

// ** Custom Components
import Sidebar from '@components/sidebar';

// ** Utils
import { selectThemeColors } from '@utils';
import codes from '../../../utility/codes';
import {
  genderOptions,
  membershipOptions,
  statusOptions
} from '../../../utility/Options';

import { handleError } from '@components/toast';
import Select from 'react-select';
// ** Third Party Components
import * as yup from 'yup';
import { Formik } from 'formik';

// ** Reactstrap Imports
import { Button, Label, FormFeedback, Form, Input, Row, Col } from 'reactstrap';

// ** Graphql
import { CREATE_USER, UPDATE_USER } from '../../../graphql/Mutation/users';
import { useMutation } from '@apollo/client';

const FormSidebar = ({
  open,
  toggleSidebar,
  defaultValues,
  handleFetching
}) => {
  // ** mutations **
  const [fechUser, { loading }] = useMutation(
    defaultValues?._id ? UPDATE_USER : CREATE_USER
  );
  // ** States
  const handleSidebarClosed = () => {};

  const countryOptions = codes.map((country) => {
    return { value: country.name_es, label: country.name_es };
  });

  const codesOptions = codes.map((country) => {
    return {
      value: country.dial_code,
      label: `${country.dial_code} ${country.name_es}`
    };
  });

  // ** Schema yup
  const Schema = yup.object().shape({
    fullName: yup.string().required('Ingresa tu nombre completo'),
    email: yup
      .string()
      .email('Correo inválido')
      .required('Tienes que ingresar un correo'),
    phone: yup
      .string()
      .min(6, 'Ingresa un número de celular')
      .max(15)
      .required('Ingresa un número de celular'),
    country: yup.string().required('Ingresa un país'),
    pin: yup.string().min(4, '4 números').max(4).required('Crea un pin')
  });

  const onSubmit = async (values) => {
    const data = {
      fullName: values.fullName,
      email: values.email,
      phone: `${values.phonecode}${values.phone}`,
      phonecode: values.phonecode,
      country: values.country,
      pin: values.pin,
      gender: values.gender,
      membership: values.membership,
      status: values.status
    };
    // if (values.usedReferralCode !== '') {
    //   data.usedReferralCode = values.usedReferralCode;
    // }
    let variables = { input: data };
    if (defaultValues?._id) {
      variables = {
        input: {
          _id: defaultValues._id,
          data
        }
      };
    }
    try {
      await fechUser({
        variables
      });
      toggleSidebar();
      handleFetching();
    } catch (e) {
      handleError(e);
    }
  };

  const handleValidateForm = async ({ validateForm, setErrors, values }) => {
    const errors = await validateForm();
    if (Object.keys(errors).length) {
      setErrors(errors);
      return;
    }
    await onSubmit(values);
  };

  const onlyNumbers = ({ e, setFieldValue, field }) => {
    const result = e.target.value.replace(/\D/g, '');
    setFieldValue(field, result);
  };

  return (
    <Sidebar
      size="lg"
      open={open}
      title={defaultValues?._id ? 'Editar Usuario' : 'Crear Usuario'}
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={toggleSidebar}
      onClosed={handleSidebarClosed}
    >
      <Formik
        initialValues={defaultValues}
        validateOnChange
        validateOnBlur
        validationSchema={Schema}
      >
        {({
          values,
          handleChange,
          handleBlur,
          errors,
          setErrors,
          validateForm,
          setFieldValue
        }) => (
          <Form>
            <div className="mb-1">
              <Label className="form-label" for="fullName">
                Nombre Completo <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="fullName"
                id="fullName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.fullName}
                placeholder="Nombre completo"
                invalid={errors.fullName && true}
              />
              {errors.fullName && (
                <FormFeedback>{errors.fullName}</FormFeedback>
              )}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="phone">
                Teléfono <span className="text-danger">*</span>
              </Label>
              <Row>
                <Col md="4">
                  <Select
                    name="phonecode"
                    id="phonecode"
                    isClearable={false}
                    classNamePrefix="select"
                    theme={selectThemeColors}
                    defaultValue={codesOptions.find(
                      (option) => option.value === values.phonecode
                    )}
                    onChange={(selectedOption) => {
                      setFieldValue('phonecode', selectedOption.value);
                    }}
                    options={codesOptions}
                  />
                </Col>
                <Col md="8">
                  <Input
                    type="text"
                    name="phone"
                    id="phone"
                    onChange={(e) =>
                      onlyNumbers({ e, setFieldValue, field: 'phone' })
                    }
                    maxLength={15}
                    minLength={6}
                    onBlur={handleBlur}
                    value={values.phone}
                    placeholder="3001234567"
                    invalid={errors.phone && true}
                  />
                  {errors.phone && <FormFeedback>{errors.phone}</FormFeedback>}
                </Col>
              </Row>
            </div>
            <div className="mb-1">
              <Label className="form-label" for="email">
                Correo <span className="text-danger">*</span>
              </Label>
              <Input
                type="email"
                name="email"
                id="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                placeholder="admin@dominio.com"
                invalid={errors.email && true}
              />
              {errors.email && <FormFeedback>{errors.email}</FormFeedback>}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="gender">
                Género <span className="text-danger">*</span>
              </Label>
              <Select
                name="gender"
                id="gender"
                isClearable={false}
                classNamePrefix="select"
                placeholder="Selecciona Género"
                theme={selectThemeColors}
                defaultValue={genderOptions.find(
                  (option) => option.value === values.gender
                )}
                onChange={(selectedOption) => {
                  setFieldValue('gender', selectedOption.value);
                }}
                options={genderOptions}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" for="country">
                País <span className="text-danger">*</span>
              </Label>
              <Select
                name="country"
                id="country"
                isClearable={false}
                classNamePrefix="select"
                placeholder="Selecciona país"
                theme={selectThemeColors}
                defaultValue={countryOptions.find(
                  (option) => option.value === values.country
                )}
                onChange={(selectedOption) => {
                  setFieldValue('country', selectedOption.value);
                }}
                options={countryOptions}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" for="membership">
                Membresia <span className="text-danger">*</span>
              </Label>
              <Select
                name="membership"
                id="membership"
                isClearable={false}
                classNamePrefix="select"
                placeholder="Selecciona Membresia"
                theme={selectThemeColors}
                defaultValue={membershipOptions                 
                  .find((option) => option.value === values.membership)}
                onChange={(selectedOption) => {
                  setFieldValue('membership', selectedOption.value);
                }}
                options={membershipOptions}
              />
            </div>            
            <div className="mb-1">
              <Label className="form-label" for="pin">
                PIN <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="pin"
                id="pin"
                maxLength={4}
                onChange={(e) =>
                  onlyNumbers({ e, setFieldValue, field: 'pin' })
                }
                onBlur={handleBlur}
                value={values.pin}
                placeholder="1234"
                invalid={errors.pin && true}
              />
              {errors.pin && <FormFeedback>{errors.pin}</FormFeedback>}
            </div>
            <div className="mb-1">
              <Label className="form-label" for="membership">
                Estado <span className="text-danger">*</span>
              </Label>
              <Select
                name="status"
                id="status"
                isClearable={false}
                classNamePrefix="select"
                placeholder="Selecciona status"
                theme={selectThemeColors}
                defaultValue={statusOptions.find(
                  (option) => option.value === values.status
                )}
                onChange={(selectedOption) => {
                  setFieldValue('status', selectedOption.value);
                }}
                options={statusOptions}
              />
            </div>
            <Button
              className="me-1 mt-1"
              color="primary"
              onClick={() =>
                handleValidateForm({ validateForm, setErrors, values })
              }
            >
              {loading
                ? `Procesando...`
                : defaultValues?._id
                ? `Actualizar`
                : `Crear`}
            </Button>
          </Form>
        )}
      </Formik>
    </Sidebar>
  );
};

export default FormSidebar;
